import { StatusCard } from "../../ThemedComponents/StatusCard";

export interface TransactionStatusMessage {
  status: string;
  content: string;
  chain: string;
}
export const TransactionStatus = ({ message }: { message: string }) => {
  const parsedMessage: TransactionStatusMessage = JSON.parse(message);
  const { status, content, chain } = parsedMessage;

  return (
    <>
      {status === "success" ? (
        <SuccessStatusCard transactionHash={content} />
      ) : (
        <ErrorStatusCard error={content} />
      )}
    </>
  );
};

const SuccessStatusCard = ({
  transactionHash,
}: {
  transactionHash: string;
}) => {
  const explorerLink = "https://kavascan.io/tx";

  const chainName = "Kava";
  return (
    <StatusCard
      title="Transaction Confirmed!"
      message={
        <div className="text-gray-400">
          <span>
            {`Your transaction has been successfully signed and submitted to the ${chainName} blockchain.`}
          </span>
          <br />
          <br />
          <a
            href={`${explorerLink}/${transactionHash}`}
            target="_blank"
            rel="noreferrer"
            className="text-blue-500"
          >
            View on {chainName} Explorer
          </a>
        </div>
      }
      status="success"
    />
  );
};

const ErrorStatusCard = ({ error }: { error: string }) => {
  return (
    <StatusCard
      title="Transaction Error"
      message={<span className="text-red-500">{error}</span>}
      status="error"
    />
  );
};
